import React from 'react';
import SubMenuBar from './SubMenuBar';
import './Template2.css';

function Blocked() {
  const menus = {};
  return (
    <div className="template2-container">
      <SubMenuBar menus={menus} />
      <div className="template2-content" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 300 }}>
        <h1>Access Denied</h1>
        <p style={{ color: '#c00', fontWeight: 600, fontSize: 18, textAlign: 'center' }}>
          You have been blocked from accessing this site.
        </p>
      </div>
    </div>
  );
}

export default Blocked; 